import esContent from './studioPlans.es';

export default {
  ...esContent,
};
